import { List, Datagrid, TextField, ShowButton, SimpleList, ReferenceField } from "react-admin";
import { settings } from "app";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { careerCenterRequests } from "api/careerCenterApi";
import { MobileListRow } from "features/MobileListRow";

const ListEmployers = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  return (
    <List exporter={false}>
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              style={{ marginRight: 16 }}
              fields={[{ label: "Име на фирмата", value: record.companyName }]}
            />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Лице за контакт", value: record.contactPerson }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: (
                      <ReferenceField
                        label="Статус"
                        source="status"
                        reference={careerCenterRequests.getStatusesSelect()}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={record => <ShowButton label="" />}
        />
      ) : (
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
        >
          <TextField
            label="Име на фирмата"
            source="companyName"
            sortable="false"
          />
          <TextField
            label="Лице за контакт"
            source="contactPerson"
            sortable="false"
          />

          <ReferenceField
            label="Статус"
            source="status"
            reference={careerCenterRequests.getStatusesSelect()}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListEmployers;
